import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	prioritySchemeNameMaxLengthValidationError: {
		id: 'admin-pages-priority-schemes.controllers.priority-scheme-name-max-length-validation-error',
		defaultMessage: 'The name you entered is too long. You can use up to {maxLength} characters.',
		description:
			'priority scheme form name field validation error where the field has reached its maximum possible length',
	},
	prioritySchemeNameFieldEmptyValidationError: {
		id: 'admin-pages-priority-schemes.controllers.priority-scheme-name-field-empty-validation-error',
		defaultMessage: 'You must specify a name for the priority scheme to be added.',
		description: 'priority scheme form name field validation error where the field is empty',
	},
	prioritySchemeDescriptionMaxLengthValidationError: {
		id: 'admin-pages-priority-schemes.controllers.priority-scheme-description-max-length-validation-error',
		defaultMessage:
			'The description you entered is too long. You can use up to {maxLength} characters.',
		description:
			'priority scheme form description field validation error where the field has reached its maximum possible length',
	},
	prioritySchemePrioritiesFieldEmptyValidationError: {
		id: 'admin-pages-priority-schemes.controllers.priority-scheme-priorities-field-empty-validation-error',
		defaultMessage: 'You must select at least one priority.',
		description:
			'Validation error for the priority scheme form where there are no priorities selected',
	},
});
export default messages;
